import { render, staticRenderFns } from "./shipment-claim-tempate.vue?vue&type=template&id=32b06d24&scoped=true&"
import script from "./shipment-claim-tempate.vue?vue&type=script&lang=js&"
export * from "./shipment-claim-tempate.vue?vue&type=script&lang=js&"
import style0 from "./shipment-claim-tempate.vue?vue&type=style&index=0&id=32b06d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b06d24",
  null
  
)

export default component.exports